import { render, staticRenderFns } from "./setUpzhiliuping.vue?vue&type=template&id=336f9780&scoped=true&"
import script from "./setUpzhiliuping.vue?vue&type=script&lang=js&"
export * from "./setUpzhiliuping.vue?vue&type=script&lang=js&"
import style0 from "./setUpzhiliuping.vue?vue&type=style&index=0&id=336f9780&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f9780",
  null
  
)

export default component.exports